import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AppleCallbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleAppleCallback = async () => {
      try {
        // URL에서 파라미터 추출
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const id_token = urlParams.get('id_token');

        if (!code) {
          throw new Error('No authorization code received');
        }

        // 서버로 코드 전송하여 토큰 교환
        const response = await fetch('/api/auth/apple', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code,
            id_token,
            state,
          }),
        });

        const data = await response.json();

        if (data.success) {
          // 로그인 성공
          localStorage.setItem('token', data.token);
          localStorage.setItem('user', JSON.stringify(data.user));
          
          // 메인 페이지로 리다이렉트
          navigate('/dashboard');
        } else {
          throw new Error(data.error || 'Login failed');
        }
      } catch (error) {
        console.error('Apple callback error:', error);
        // 에러 페이지로 리다이렉트
        navigate('/login?error=apple_login_failed');
      }
    };

    handleAppleCallback();
  }, [location, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <div>
        <h2>Apple 로그인 처리 중...</h2>
        <p>잠시만 기다려주세요.</p>
      </div>
    </div>
  );
};

export default AppleCallbackPage;